import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';

import { map, filter, includes, intersection, size } from 'lodash';
// import Lottie from 'react-lottie';

import ReactGA from 'react-ga';
import Iframe from 'react-iframe';
import classNames from 'classnames';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';
import TabContent from 'reactstrap/lib/TabContent';
import TabPane from 'reactstrap/lib/TabPane';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
// import ModalFooter from 'reactstrap/lib/ModalFooter';

// import { loadStripe } from '@stripe/stripe-js';

import moment from 'moment';
import Moment from 'react-moment';

import ScrollAreaWrapper from '../Components/ScrollAreaWrapper';
import RedeemGiftCode from './Shop/RedeemGiftCode';

import CustomDate from '../Components/Components/CustomDate';

import config from '../../../../constants/config';
import * as constants from '../../../../constants/constants';
import { generalMessages } from '../../../../constants/messages';

// import InviteFriend from './InviteFriend';

import coins1 from '../../../../images/redesign/buy-page/coins_1.webp';
import coins2 from '../../../../images/redesign/buy-page/coins_2.webp';
import coins3 from '../../../../images/redesign/buy-page/coins_3.webp';
import coins4 from '../../../../images/redesign/buy-page/coins_4.webp';
import coins5 from '../../../../images/redesign/buy-page/coins_5.webp';

// import shopImg from '../../../images/icons/shoping_cart.webp';

import bonus1 from '../../../../images/icons/money_bonus_1.svg';
import bonus2 from '../../../../images/icons/money_bonus_2.svg';
import bonus3 from '../../../../images/icons/money_bonus_3.svg';
import bonus4 from '../../../../images/icons/money_bonus_4.svg';

import coinImg from '../../../../images/redesign/common/coin.svg';
// import glitterAnimImg from '../../../images/BuyMoney/glitter.json';

import balanceResetImg from '../../../../images/redesign/buy-page/balance_reset.svg';
import pointsResetImg from '../../../../images/redesign/buy-page/points_reset.svg';
import profileResetImg from '../../../../images/redesign/buy-page/profile_reset.svg';
import hideAdsMonthImg from '../../../../images/redesign/buy-page/hideAdsMonth.svg';
import hideAdsYearImg from '../../../../images/redesign/buy-page/hideAdsYear.svg';
import buyVipImg from '../../../../images/redesign/buy-page/vipImage.svg';

import noTransactionImgDark from '../../../../images/redesign/buy-page/no-transactions.svg';
import noTransactionImgLight from '../../../../images/redesign/light-mode/buy-page/no-transactions.svg';



import infoImg from '../../../../images/redesign/player/info.svg';
import lightInfoImg from '../../../../images/redesign/light-mode/player/info.svg';
import mobileImg from '../../../../images/redesign/buy-page/mobile.png';

import closeImg from '../../../../images/icons/close.png';

// import buttonClickedSound from '../../../../sounds/click_feedback.flac';
import DateFormat from '../../UI/DateFormat';
import DiscountTimer from '../Components/Components/Timer';
import CustomModal from '../Components/Components/Modal';
import PaymentTypeContent from './Modals/PaymentTypeContent';

import {
  initFBPayment,
  initDraugiemPayment,
  initInboxPayment,
  initEveryPayPayment,
  fbPaymentCallback,
  initStripePayment,
  getTransactionsHistory,
  claimGiftCode,
  verifyGiftCode,
  cancelEveryPayPayment,
} from '../../../../actions/member';

import {
  getDiscounts, setLastShopTab, setTransactionComplete
} from '../../../../actions/shop';
import { isMobileDevice } from '../../../../utils/deviceUtils';

const buttonClickedSound = '/sounds/click_feedback.flac';

class AdsPackageModal extends React.Component {
  static propTypes = {
    //  t: PropTypes.func.isRequired,
    initFBPay: PropTypes.func.isRequired,
    fbCallback: PropTypes.func.isRequired,
    initDraugiemPay: PropTypes.func.isRequired,
    initInboxPay: PropTypes.func.isRequired,
    initStripePay: PropTypes.func.isRequired,
    initEveryPay: PropTypes.func.isRequired,
    cancelEveryPay: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    fetchTransactionsHistory: PropTypes.func.isRequired,
    totalPoints: PropTypes.number,
    balance: PropTypes.number,
    parentActiveTab: PropTypes.string,
    isFullscreen: PropTypes.bool,
    isFullscreenEnabled: PropTypes.bool,
    toggleFullscreen: PropTypes.func,
    socProvider: PropTypes.string,
  //  userSettings: PropTypes.shape({
  //    soundOn: PropTypes.bool,
   // }),
    claimGift: PropTypes.func.isRequired,
    verifyGift: PropTypes.func.isRequired,
    switchToggle: PropTypes.func.isRequired,
    toggleStripeLoading: PropTypes.func.isRequired,
    screenMode: PropTypes.bool,
    fetchDiscounts: PropTypes.func.isRequired,
    discounts: PropTypes.arrayOf(PropTypes.shape({})),
    toggleAboutUs: PropTypes.func.isRequired,
    toggleTerms: PropTypes.func.isRequired,
    setLastShopTabFunc: PropTypes.func.isRequired,
    lastShopTab: PropTypes.string,
    transactionComplete: PropTypes.bool,
    paymentInfo: PropTypes.shape({}),
    isAdHidePackageModal: PropTypes.bool,
    handleAdHidePackageModal: PropTypes.func.isRequired,
  }

  static defaultProps = {
    totalPoints: null,
    balance: null,
    parentActiveTab: null,
    isFullscreen: false,
  //  userSettings: {},
    socProvider: null,
    screenMode: constants.SCREEN_MODE.normal,
    discounts: [],
    paymentInfo: {},
    isAdHidePackageModal: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      // activeTab: this.props.parentActiveTab === constants.MENU_NAVIGATION.giftPage ? constants.SHOP_NAVIGATION.discountEvent : this.props.parentActiveTab === constants.MENU_NAVIGATION.resetBalancePage ? constants.SHOP_NAVIGATION.premiumPacks : constants.SHOP_NAVIGATION.moneyPacks,
      pauseGlitter: [true, true, true, true, true],
      processing: false,
      activeHover: null,
      showInboxPayment: false,
      inboxIframeLink: null,
      historyData: [],
      scrollPos: 0,
      code: '',
      loading: false,
      selectCode: '',
      selectValue: '',
      redeemFlag: false,
      verifiedCode: '',
      giftStatus: '',
      giftMessage: '',
      giftMessageVisible: false,
      curDate: new Date(),
      curDay: 0,
      buyModal: false,
      paymentErrorModal: false,
      selectedPaymentOption: constants.PAYMENT_TYPES.swedbank,
      selectedProduct: {},
      selectedProductId: 0,
      isOnline: navigator.onLine,
      devMode: false,
      checkedTerms: false,
      paymentError: '',
      smsPaymentModal: false,
      curState: null,
    };

    this.buttonClickedAudio = new Audio(buttonClickedSound);
  }

  componentDidMount() {
    const { t } = this.props;
    const { pauseGlitter, curDate, curDay } = this.state;
    const pauseGlitterCopy = [...pauseGlitter];

    const { fetchDiscounts } = this.props;
    const { hostname } = window.location;

    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);

    let devModeTemp = false;

    if (hostname && (hostname.includes('dev') || hostname.includes('localhost'))) {
      devModeTemp = true;
      this.setState({
        devMode: devModeTemp,
      });
    }


    fetchDiscounts(devModeTemp);

    this.intervalID = setInterval(() => {
      this.setState({
        curDate: Date.now(),
      });
      if (curDay !== curDate.getDate()) {
        this.setState({
          curDay: curDate.getDate(),
        });
      }
    }, 1000);


    setTimeout(() => {
      pauseGlitterCopy[0] = false;
      this.setState({ pauseGlitter: pauseGlitterCopy });
    }, 0);

    setTimeout(() => {
      pauseGlitterCopy[4] = false;
      this.setState({ pauseGlitter: pauseGlitterCopy });
    }, 270);

    setTimeout(() => {
      pauseGlitterCopy[1] = false;
      this.setState({ pauseGlitter: pauseGlitterCopy });
    }, 500);

    setTimeout(() => {
      pauseGlitterCopy[3] = false;
      this.setState({ pauseGlitter: pauseGlitterCopy });
    }, 750);

    setTimeout(() => {
      pauseGlitterCopy[2] = false;
      this.setState({ pauseGlitter: pauseGlitterCopy });
    }, 1000);

    this.setState({
      giftMessage: generalMessages.enterGiftCode,
    });

    this.fetchTransactionsHistory();
  }

  componentDidUpdate(prevProps, prevState) {
    const { parentActiveTab: prevParentActiveTab } = prevProps;
    const { parentActiveTab, lastShopTab, transactionComplete, setTransactionCompleteFunc, switchToggle } = this.props;

    const { activeTab: prevActiveTab } = prevState;
    const { activeTab, showInboxPayment } = this.state;

  //  console.log('showInboxPayment', showInboxPayment, transactionComplete);

    if (lastShopTab && transactionComplete) {
      // this.setState({
      //   activeTab: lastShopTab === 'moneyPacks' ? constants.SHOP_NAVIGATION.moneyPacks : constants.SHOP_NAVIGATION.premiumPacks,
      // });
      switchToggle(lastShopTab === 'moneyPacks' ? constants.MENU_NAVIGATION.buyPageMoneyPacks : constants.MENU_NAVIGATION.buyPagePremiumPacks);
      setTransactionCompleteFunc(false);

      if (showInboxPayment) {
        this.closeInboxModal();
      }
    }

    // if (prevParentActiveTab === constants.MENU_NAVIGATION.giftPage) {
    //   if (activeTab !== constants.MENU_NAVIGATION.buyPage) {
    //     this.setState({
    //       activeTab: constants.SHOP_NAVIGATION.discountEvent,
    //     });
    //   }
    // }
    // if (prevParentActiveTab !== parentActiveTab) {

    //   if (parentActiveTab === constants.MENU_NAVIGATION.resetBalancePage) {
    //     this.setState({
    //       activeTab: constants.SHOP_NAVIGATION.premiumPacks,
    //     });
    //   }
    //   if (parentActiveTab === constants.MENU_NAVIGATION.moneyPacks) {
    //     this.setState({
    //       activeTab: constants.SHOP_NAVIGATION.moneyPacks,
    //     });
    //   }
    // }

    // if (activeTab !== prevActiveTab && activeTab === constants.SHOP_NAVIGATION.redeemGiftCode) {
    //   this.setState({giftMessageVisible: false});
    // }

    // console.log(activeTab, prevParentActiveTab, parentActiveTab, "check parent activate tab");
  }

  componentWillUnmount() {
    try {
      clearInterval(this.intervalID);
      window.removeEventListener('online', this.handleOnline);
      window.removeEventListener('offline', this.handleOffline);
    } catch (err) {
      console.log('err componentWillUnmount');
    }
  }

  handleOnline = () => {
    this.setState({ isOnline: true });
  }

  handleOffline = () => {
    this.setState({ isOnline: false });
  }

  toggle = (tab) => {
    const { switchToggle, parentActiveTab } = this.props;
    // const { activeTab } = this.state;
    if (parentActiveTab !== tab) {
      // this.setState({
      //   activeTab: tab,
      // });
      switchToggle(tab);

      if (tab === constants.MENU_NAVIGATION.buyPageMoneyPacks) {
        ReactGA.event({
          category: 'Menu',
          action: 'Shop - Money Packages',
        });
      } else if (tab === constants.MENU_NAVIGATION.buyPagePremiumPacks) {
        ReactGA.event({
          category: 'Menu',
          action: 'Shop - Premium Packages',
        });
      } else if (tab === constants.MENU_NAVIGATION.buyPageHistory) {
        ReactGA.event({
          category: 'Menu',
          action: 'Open Purchase History',
        });
      } else if (tab === constants.MENU_NAVIGATION.buyPageRedeemCode) {
        ReactGA.event({
          category: 'Menu',
          action: 'Shop - Redeem Gift',
        });
      }

      /*  if (tab === '3') {
          ReactGA.event({
            category: 'Menu',
            action: 'Open Purchase History',
          });
        } */
    }
  }

  onPaymentOptionClick = (option) => {
    this.setState({
      selectedPaymentOption: option
    });
  }

  toggleBuyModal = () => {
    const { paymentInfo, cancelEveryPay } = this.props;
    const { selectedProductId, buyModal} = this.state;

    if (buyModal) {
      cancelEveryPay(selectedProductId, paymentInfo)
    }
    this.setState({buyModal: !this.state.buyModal});
  }

  togglePaymentErrorModal = (paymentError) => {
    this.setState({
      paymentErrorModal: !this.state.paymentErrorModal,
      paymentError
    });
  }

  pay = () => {
    const { selectedPaymentOption, selectedProduct, selectedProductId, checkedTerms } = this.state;
    const { toggleStripeLoading, initEveryPay, t, i18n, paymentInfo } = this.props;

    if (!checkedTerms) {
      this.togglePaymentErrorModal(t('paymentType.acceptTerms'));
    } else if (![constants.PAYMENT_TYPES.paypal.id].includes(selectedPaymentOption.id)) {
      if (constants.PAYMENT_TYPES.textMessage.id !== selectedPaymentOption.id) {
        toggleStripeLoading(true);

        initEveryPay(selectedProduct, selectedPaymentOption, selectedProductId, i18n.language, paymentInfo).then((res) => {
          if (res && res.data && res.data.payment_link && res.data.status !== 'error') {
            const paymentLink = res.data.payment_link;
            if (paymentLink) {
              window.location.href = paymentLink;
            }
          } else {
            toggleStripeLoading(false);
            this.togglePaymentErrorModal(t('paymentType.notAvailable'));
          }
        }).catch((error) => {
          toggleStripeLoading(false);
          console.log(error);
        });
      } else {
        this.toggleSmsPaymentModal();
      }
    } else {
      this.togglePaymentErrorModal(t('paymentType.notAvailable'));
    }
  }


  buyMoney = (prod) => {
    const {
      initFBPay, fbCallback, socProvider, initDraugiemPay, initInboxPay, toggleStripeLoading, discounts, isFullscreen, isFullscreenEnabled, toggleFullscreen, setLastShopTabFunc, paymentInfo, tournamentTickets
    } = this.props;
    const { devMode, curState, processingPayClick } = this.state;

    if (tournamentTickets && tournamentTickets[constants.TOURNAMENT_TICKETS_ID[prod]]) return;

    if (prod <= 5) {
      setLastShopTabFunc('moneyPacks');
    } else {
      setLastShopTabFunc('premiumPacks');
    }

  //  console.log('buyMoney processingPayClick', processingPayClick);

    if (processingPayClick) {
      return null;
    }

    this.setState({ processingPayClick: true });

    if (config.isInAppFrame() && isFullscreenEnabled) {
      toggleFullscreen();
    }

    if (!config.isInAppFrame()) {
      this.playButtonSound();

      this.setState({ processingPayClick: false });

      if (devMode || !devMode) {
        const selectedProduct = { ...constants.BUY_PAGE_PRODUCTS[prod] };
        if (discounts && discounts[0] && discounts[0].type === constants.SPECIALPRICE && curState === constants.CURRENT) {
          selectedProduct.realPrice = discounts[0].specialPrice[this.renderProductLabel(prod)];
          selectedProduct.discountType = constants.SPECIALPRICE;
        } else if (discounts && discounts[0] && discounts[0].type === constants.DISCOUNTPRICE && curState === constants.CURRENT) {
          const productMoney = filter(constants.SHOP_PRODUCT_TYPES, (item) => { return item.id === prod; })[0];
          selectedProduct.discountType = constants.DISCOUNTPRICE;

          if (productMoney && includes(discounts[0].selectedDiscountPackage, productMoney.label)) {
            selectedProduct.realPrice = parseFloat(productMoney.realPrice - ((productMoney.realPrice/100) * discounts[0].discountPrice)).toFixed(2)
          }
        } else if (discounts && discounts[0] && discounts[0].type === constants.BONUS && curState === constants.CURRENT) {
          const productMoney = filter(constants.SHOP_PRODUCT_TYPES, (item) => { return item.id === prod; })[0];
          selectedProduct.discountType = constants.BONUS;

          if (productMoney && includes(discounts[0].selectedDiscountPackage, productMoney.label)) {
            selectedProduct.realPrice = discounts[0].discountPrice;
          }
        }

        this.setState({ selectedProduct, selectedProductId: prod });
        this.toggleBuyModal();
      } else {
        // this.playButtonSound();

       //  this.setState({ processing: true });
       //  toggleStripeLoading(true);
       //  const { initStripePay } = this.props;

         //  const failTxt = t('menu.stripeShopNotWorking');

         /* initStripePay(prod).then((result) => {
           if (result.data && result.data.data.status && result.data.data.status === 'success' && result.data.data.id) {
             const paymentSessionId = result.data.data.id;

             loadStripe(config.stripeBublicKey).then((stripe) => {
               stripe.redirectToCheckout({
                 sessionId: paymentSessionId,
               })
                 .then(() => {
                   //  alert(failTxt);
                   toggleStripeLoading(false);
                   this.setState({ processing: false });
                 });
             }).catch(() => {
               //  alert(failTxt);
               toggleStripeLoading(false);
               this.setState({ processing: false });
             });
           } else if (result.data.data && !result.data.data.status) {
             //  alert(failTxt);
             toggleStripeLoading(false);
             this.setState({ processing: false });
           } else if (result.data.data && result.data.data.status && result.data.data.status === 'error') {
             //  alert(failTxt);
             toggleStripeLoading(false);
             this.setState({ processing: false });
           }
         }).catch((e) => {
           //  alert(failTxt);
           console.log(e);
           toggleStripeLoading(false);
           this.setState({ processing: false });
         }); */
      }

      // return;
    } else if (socProvider === 'facebook') { // In App Iframe (fb/dra)
      this.playButtonSound();

      this.setState({ processingPayClick: false });

      initFBPay(prod, paymentInfo).then((res) => {
        console.log(res.data.data);
        if (res.data && res.data.data && res.data.data.status === 'success') {
          const { product } = res.data.data;

          if (product) {
            if (window.FB && socProvider === 'facebook') {
              window.FB.ui({
                method: 'pay',
                action: 'purchaseitem',
                product,
                quantity: 1, // optional, defaults to 1
                request_id: res.data.data.token, // optional, must be unique for each payment
              },
                (resp) => {
                  console.log('fb pay resp', { resp });
                  fbCallback(resp);
                  return null;
                });
            } else {
              console.log('no FB.ui or not facebook provider');
            }
          } else {
            console.log('error with product');
          }
        }
      }).catch((err) => {
        this.setState({ processingPayClick: false });
      });
    } else if (socProvider === 'draugiem') {
      this.playButtonSound();

      this.setState({ processingPayClick: false });

      initDraugiemPay(prod, paymentInfo).then((res) => {
        console.log('res');
        console.log(res.data.data);
        if (res.data && res.data.data && res.data.data.status === 'success') {
          const { product } = res.data.data;

          if (product) {
            if (window.draugiemWindowOpen && socProvider === 'draugiem') {
              window.draugiemWindowOpen(product, 350, 400);
            } else {
              console.log('no draugiemWindowOpen or not draugiem provider');
            }
          } else {
            console.log('error with product');
          }
        }
      }).catch((err) => {
        this.setState({ processingPayClick: false });
      });
    } else if (socProvider === 'inbox') {
      this.playButtonSound();
      initInboxPay(prod, paymentInfo).then((res) => {
        this.setState({ processingPayClick: false });

        console.log('res');
        console.log(res.data.data);
        if (res.data && res.data.data && res.data.data.status === 'success') {
          const { product } = res.data.data;

          if (product) {
            this.setState({ showInboxPayment: true, inboxIframeLink: product });
          } else {
            console.log('error with product');
          }
        }
      }).catch((err) => {
        this.setState({ processingPayClick: false });
      });
    }
  }

  closeInboxModal = () => {
    console.log('closeInboxModal');
    this.setState({ showInboxPayment: false, inboxIframeLink: null });
  }

  mouseEnter = (key) => {
  //  console.log('mouseEnter', key);

    this.setState({ activeHover: key });
  }

  mouseLeave = () => {
  //  console.log('mouseLeave');

    this.setState({ activeHover: null });
  }

  playButtonSound = () => {
    const { soundOn } = this.props;

      if (soundOn) {
        const playPromise = this.buttonClickedAudio.play();
        if (playPromise !== undefined) {
          playPromise
            .then(_ => {
              // Automatic playback started!
              // Show playing UI.
              console.log("audio played auto");
            })
            .catch(error => {
              // Auto-play was prevented
              // Show paused UI.
              console.log("playback prevented");
            });
        }
      }
  }


  fetchTransactionsHistory = () => {
    const { fetchTransactionsHistory } = this.props;

    fetchTransactionsHistory().then((res) => {
      if (res) {
        const array = [];

        Object.keys(res).map((key) => {
          array.push({ key, ...res[key] });
          return null;
        });

        array.sort((a, b) => (b.dateInitiated - a.dateInitiated));

        this.setState({ openHistory: false, historyData: array });

      } else {
        this.setState({ openHistory: false, historyData: [] });

      }
    });
  }

  closeHistory = () => {
    this.setState({ openHistory: false, historyData: null });
  }

  updateScrollPos = (val) => {
    this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.messagesScrollbar.scrollYTo(newVal);
  }

  handleInputChange = (val) => {
    this.setState({
      code: val,
    });
  }

  verifyGift = () => {
    const {
      verifyGift,
      t,
    } = this.props;

    const {
      code,
    } = this.state;

    this.setState({ loading: true });
    let giftMessage = '';
    let giftStatus = '';
    if (code.length > 10 || code.length <= 3) {
      return this.setState({
        loading: false,
        giftStatus: constants.FROUNT_SIDE_STATUS.error,
        giftMessage: generalMessages.giftCodeLongFailed,
        giftMessageVisible: true,
      });
    }

    verifyGift(code).then((res) => {
      if (res.status === constants.FROUNT_SIDE_STATUS.success) {
        //showNotification(t('common.success'), t('common.verifySuccess'), 'success');
        this.setState({
          loading: false,
          selectCode: res.selCode,
          selectValue: res.selVal,
          verifiedCode: code,
          giftMessageVisible: true,
          giftStatus: constants.FROUNT_SIDE_STATUS.success,
          giftMessage: generalMessages.verifySuccessMessage,
        });
      }
      if (res.status === constants.FROUNT_SIDE_STATUS.error) {
        giftStatus = constants.FROUNT_SIDE_STATUS.error;
        if (res.error === constants.GIFT_CODE_ERROR_STATUS.missingGiftCode) {
          giftMessage = generalMessages.enterGiftCode;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.wrongCode) {
          giftMessage = generalMessages.wrongCode;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.codeExpired) {
          giftMessage = generalMessages.codeExpire;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.limitClaim) {
          giftMessage = generalMessages.limitClaim;
        } else {
          giftMessage = res.error;
          // showNotification(t('common.error!'), res.error, 'danger');
        }
        this.setState({
          loading: false,
          giftStatus,
          giftMessage,
          giftMessageVisible: true,
        });
      } else {
        this.claimGift();
        this.setState({code: ''});
      }
    }).catch(error => {
      this.setState({
        loading: false,
        giftStatus: constants.FROUNT_SIDE_STATUS.error,
        giftMessage: error.message,
        giftMessageVisible: true,
      });
    });
  }

  claimGift = () => {
    const {
      claimGift,
      t,
    } = this.props;

    const {
      verifiedCode,
      selectValue,
      selectCode,
      code,
    } = this.state;
    this.setState({ loading: true });
    let giftMessage = '';
    let giftStatus = '';
    if (code.length > 10) {
      return this.setState({
        loading: false,
        giftStatus: constants.FROUNT_SIDE_STATUS.error,
        giftMessage: generalMessages.giftCodeLongFailed,
        giftMessageVisible: true,
      });
    }
    claimGift(verifiedCode).then(res => {
      if (res.status === constants.FROUNT_SIDE_STATUS.success) {
        this.setState({
          redeemFlag: true,
          verifiedCode: '',
          giftStatus: constants.FROUNT_SIDE_STATUS.completed,
          giftMessage: generalMessages.claimSuccessMessage,
          code: '',
          loading: false,
          giftMessageVisible: true,
        });
      }
      if (res.status === constants.FROUNT_SIDE_STATUS.error) {
        giftStatus = constants.FROUNT_SIDE_STATUS.error;
        if (res.error === constants.GIFT_CODE_ERROR_STATUS.missingGiftCode) {
          giftMessage = generalMessages.enterGiftCode;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.wrongCode) {
          giftMessage = generalMessages.wrongCode;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.codeExpired) {
          giftMessage = generalMessages.codeExpire;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.limitClaim) {
          giftMessage = generalMessages.limitClaim;
        } else if (res.error === constants.GIFT_CODE_ERROR_STATUS.alreadyClaimed) {
          giftMessage = generalMessages.alreadyClaimed;
        } else {
          giftMessage = res.error;
        }
        this.setState({
          loading: false,
          giftStatus,
          giftMessage,
          giftMessageVisible: true,
        });
      }
    }).catch((error) => {
      this.setState({
        loading: false,
        giftStatus: constants.FROUNT_SIDE_STATUS.error,
        giftMessage: error.message,
        giftMessageVisible: true,
      });
      // showNotification(t('common.error!'), error.message, 'danger');
    });
  }

  renderProductLabel = (prod) => {
    const selectedProd = constants.SHOP_PRODUCT_TYPES.find((item) => item.id === prod);

    return selectedProd.label;
  }

  renderSpecialAndDiscount = (product, discount, processing) => {
    const { screenMode, balance, totalPoints } = this.props;
    const { curState } = this.state;

    const productMoney = filter(constants.SHOP_PRODUCT_TYPES, (item) => { return item.id === product; })[0];

    if (productMoney && includes(discount.selectedDiscountPackage, productMoney.label)) {
      if (discount.type === constants.SPECIALPRICE) {
        return (
          <>
            <Button
              disabled={curState === constants.CURRENT}
              style={{ textDecorationLine: 'line-through' }}
              color="link"
              className={classNames('layout-default-button', {
                'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
                'layout-redHighlighted-disabled-button': screenMode === constants.SCREEN_MODE.light,
              })}
              onClick={() => this.buyMoney(product)}
            >
              {`${productMoney.realPrice} EUR`}
            </Button>
            <Button
              disabled={
                product === 6 ? (processing || curState === constants.PLANNED || (!balance || (balance > 0)))
                  : product === 7 ? (processing || curState === constants.PLANNED || (!totalPoints || (totalPoints > 0)))
                    : processing || curState === constants.PLANNED
              }
              color="link"
              className='layout-default-button layout-redHighlighted-button'
              onClick={() => this.buyMoney(product)}
            >
              {`${discount.specialPrice[this.renderProductLabel(product)]} EUR`}
            </Button>
          </>
        )
      }
      return (
        <>
          <Button
            disabled={curState === constants.CURRENT}
            style={{ textDecorationLine: curState === constants.CURRENT ? 'line-through' : '' }}
            color="link"
            className={classNames('layout-default-button', {
              'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
              'layout-redHighlighted-disabled-button': screenMode === constants.SCREEN_MODE.light,
            })}
            onClick={() => this.buyMoney(product)}
          >
            {`${productMoney.realPrice} EUR`}
          </Button>
          <Button
            disabled={
              product === 6 ? (processing || curState === constants.PLANNED || (!balance || (balance > 0)))
                : product === 7 ? (processing || curState === constants.PLANNED || (!totalPoints || (totalPoints > 0)))
                  : processing || curState === constants.PLANNED
            }
            color="link"
            className='layout-default-button layout-redHighlighted-button'
            onClick={() => this.buyMoney(product)}
          >
            {`${parseFloat(productMoney.realPrice - ((productMoney.realPrice/100) * discount.discountPrice)).toFixed(2)} EUR`}
          </Button>
        </>
      );
    }
    return (
      <Button
        disabled={
          product === 6 ? (processing || (!balance || (balance > 0)))
            : product === 7 ? (processing || (!totalPoints || (totalPoints > 0)))
              : processing
        }
        color="link"
        className={classNames('layout-default-button', {
          'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
          'layout-redHighlighted-button': screenMode === constants.SCREEN_MODE.light,
        })}
        onClick={() => this.buyMoney(1)}
      >
        {`${productMoney.realPrice} EUR`}
      </Button>
    );
  }

  renderBonus = (product, discount, processing, basePrice) => {
  //  console.log('renderBonus', product, discount);
    if (basePrice && discount.discountPrice) {
      return (
        <div className="buy-page-coins-wrapper-bonus-coins-amount">
          <Media src={coinImg} className="buy-page-coins-coin" />
          <span>{`+${basePrice * (discount.discountPrice / 100)}`}</span>
        </div>
      )
    }
  }

  toggleCheckedTerms = () => {
    this.setState(prevState => ({
      checkedTerms: !prevState.checkedTerms
    }));
  };

  toggleSmsPaymentModal = () => {
    this.setState(prevState => ({
      smsPaymentModal: !prevState.smsPaymentModal,
    }));
  };

  handleCurState = (state) => {
    this.setState({
      curState: state
    })
  }

  render() {
    const {
      t,
      i18n,
      socProvider,
      balance,
      totalPoints,
      parentActiveTab,
      isFullscreen,
      screenMode,
      discounts,
      toggleAboutUs,
      toggleTerms,
      switchToggle,
      adsHidden,
      vipUntil,
      paymentInfo,
      isAdHidePackageModal,
      handleAdHidePackageModal
    } = this.props;

    const {
      pauseGlitter,
      processing,
      activeHover,
      showInboxPayment,
      inboxIframeLink,
      openHistory,
      historyData,
      scrollPos,
      code,
      loading,
      selectCode,
      selectValue,
      redeemFlag,
      verifiedCode,
      giftStatus,
      giftMessage,
      giftMessageVisible,
      curDate,
      curDay,
      buyModal,
      paymentErrorModal,
      selectedPaymentOption,
      selectedProduct,
      isOnline,
      checkedTerms,
      paymentError,
      smsPaymentModal,
      devMode,
      curState,
    } = this.state;
  //  console.log(paymentInfo, "-------------------------paymentInfo===")

  //  console.log('activeHover', activeHover);

    // console.log(balance, totalPoints, "checkPB", parentActiveTab, constants.MENU_NAVIGATION.buyPage, constants.MENU_NAVIGATION.buyPageMoneyPacks);

    return (
      <>
        <CustomModal
          isOpen={isAdHidePackageModal}
          toggle={handleAdHidePackageModal}
          size={!config.isInDraugiemAppFrame() ? 'lg' : 'md'}
          addClassName={"payment-type-content-modal"}
          title={t('buyPage.adsPackages')}
          body={
            <div className='d-flex flex-row align-items-center gap-10 mt-4'>
              <div className="d-none flex-column align-items-center buy-page-end-time-section mt-2">
                {
                  discounts.length > 0 && (size(intersection(discounts[0].selectedDiscountPackage, constants.MONEYPACKS_TYPES)) > 0) && map(discounts, item => (
                    <Col className="d-flex flex-row align-items-center">
                      <DiscountTimer item={item} handleCurState={this.handleCurState} curState={curState} />
                    </Col>
                  ))
                }
              </div>
              <Col sm="6" className="d-flex flex-column items-center">
                <div className='buy-page-premium-wrapper d-flex justify-center flex-row'>
                  <div className='d-flex flex-column align-items-center relative'>
                    <span>{t('buyPage.hideAdsMonth')}</span>
                    <div className="buy-page-info-imageWrapper r-30">
                    <Media className="buy-page-info-image" onMouseEnter={() => this.mouseEnter('10')} onMouseLeave={() => this.mouseLeave('10')} src={screenMode === constants.SCREEN_MODE.light ? lightInfoImg : infoImg} alt="" />
                    <div className={`buy-page-info-hover buy-page-info-hover-modal ${activeHover === '10' ? null : 'display-none'}`}>
                      <label className="mr-1">{`${t('buyPage.hideAdsMonth')}:`}</label>
                      {t('buyPage.hideAdsMonthDesc')}
                    </div>
                  </div>
                  </div>
                </div>
                {
                  discounts.length > 0 && discounts[0].type === constants.BONUS && includes(discounts[0].selectedDiscountPackage, 'hideAdsMonth') && (
                    this.renderBonus(constants.SHOP_PRODUCT_NAMES.money1, discounts[0], processing)
                  )
                }
                {
                  discounts.length > 0 && (curState === constants.PLANNED || curState === constants.CURRENT) ? (
                    (discounts[0].type === constants.SPECIALPRICE && discounts[0].specialPrice['hideAdsMonth'] > 0) || discounts[0].type === constants.DISCOUNTPRICE ? (
                      this.renderSpecialAndDiscount(constants.SHOP_PRODUCT_NAMES.hideAdsMonth, discounts[0], processing)
                    ) : (
                      <Button
                        disabled={processing}
                        color="link"
                        className={classNames('layout-default-button', {
                          'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
                          'layout-redHighlighted-button': screenMode === constants.SCREEN_MODE.light,
                        })}
                        onClick={() => this.buyMoney(10)}
                      >
                        3.00 EUR
                      </Button>
                    )
                  ) : (
                    <Button
                      disabled={processing}
                      color="link"
                      className={classNames('layout-default-button', {
                        'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
                        'layout-redHighlighted-button': screenMode === constants.SCREEN_MODE.light,
                      })}
                      onClick={() => this.buyMoney(10)}
                    >
                      3.00 EUR
                    </Button>
                  )
                }
              </Col>
              {!config.isInDraugiemAppFrame() && (
              <Col sm="6" className="d-flex flex-column items-center">

                <div className='buy-page-premium-wrapper d-flex justify-center flex-row'>
                  <div className='d-flex flex-column align-items-center relative'>
                    <span>{t('buyPage.hideAdsYear')}</span>
                    <div className="buy-page-info-imageWrapper r-30">
                      <Media className="buy-page-info-image" onMouseEnter={() => this.mouseEnter('11')} onMouseLeave={() => this.mouseLeave('11')} src={screenMode === constants.SCREEN_MODE.light ? lightInfoImg : infoImg} alt="" />
                      <div className={`buy-page-info-hover buy-page-info-hover-modal ${activeHover === '11' ? null : 'display-none'}`}>
                        <label className="mr-1">{`${t('buyPage.hideAdsYear')}:`}</label>
                        {t('buyPage.hideAdsYearDesc')}
                      </div>
                    </div>
                  </div>
                </div>
                {
                  discounts.length > 0 && discounts[0].type === constants.BONUS && includes(discounts[0].selectedDiscountPackage, 'hideAdsYear') && (
                    this.renderBonus(constants.SHOP_PRODUCT_NAMES.money1, discounts[0], processing)
                  )
                }
                {
                  discounts.length > 0 && (curState === constants.PLANNED || curState === constants.CURRENT) ? (
                    (discounts[0].type === constants.SPECIALPRICE && discounts[0].specialPrice['hideAdsYear'] > 0) || discounts[0].type === constants.DISCOUNTPRICE ? (
                      this.renderSpecialAndDiscount(constants.SHOP_PRODUCT_NAMES.hideAdsYear, discounts[0], processing)
                    ) : (
                      <Button
                        disabled={processing}
                        color="link"
                        className={classNames('layout-default-button', {
                          'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
                          'layout-redHighlighted-button': screenMode === constants.SCREEN_MODE.light,
                        })}
                        onClick={() => this.buyMoney(11)}
                      >
                        25.00 EUR
                      </Button>
                    )
                  ) : (
                    <Button
                      disabled={processing}
                      color="link"
                      className={classNames('layout-default-button', {
                        'layout-darkHighlighted-button': screenMode !== constants.SCREEN_MODE.light,
                        'layout-redHighlighted-button': screenMode === constants.SCREEN_MODE.light,
                      })}
                      onClick={() => this.buyMoney(11)}
                    >
                      25.00 EUR
                    </Button>
                  )
                }
              </Col>
              )}
            </div>
          }
          footer={
            !isMobileDevice() ? (
              <Button onClick={handleAdHidePackageModal}>
              {t('common.close')}
              </Button>
            ) : (null)
          }
        />
        <CustomModal
          isOpen={buyModal}
          toggle={this.toggleBuyModal}
          size="lg"
          addClassName={"payment-type-content-modal"}
          title={t('paymentType.chooseTitle')}
          body={
            <PaymentTypeContent
              toggleAboutUs={toggleAboutUs}
              toggleTerms={toggleTerms}
              selectedProduct={selectedProduct}
              selectedPaymentOption={selectedPaymentOption}
              setSelectedPaymentOption={this.onPaymentOptionClick}
              checkedTerms={checkedTerms}
              toggleCheckedTerms={this.toggleCheckedTerms}
              t={t}
              devMode={devMode}
            />
          }
          footerClose
          footer={
            <>
              <Button onClick={this.pay} disabled={!isOnline}>
                {t('common.continue')}
              </Button>
              <Button onClick={this.toggleBuyModal} disabled={!isOnline}>
                {t('common.cancel')}
              </Button>
              <hr className={`payment-type-line-${screenMode}`} />
              <p className={`payment-type-footnote-text-${screenMode}`}>SIA 'Draxo Games'</p>
              <p className={`payment-type-footnote-text-${screenMode}`}>Liepājas 49-6, Kuldīga</p>
              <p className={`payment-type-footnote-text-${screenMode}`}>Latvija</p>
            </>
          }
        />

        <CustomModal
          isOpen={paymentErrorModal}
          toggle={() => this.togglePaymentErrorModal('')}
          size="md"
          verticalCentering
          largeText
          title={t('common.zoleInfo')}
          footerClose
          body={
            <p className="text-center">{paymentError}</p>
          }
          footer={
            <Button onClick={() => this.togglePaymentErrorModal('')}>
              {t('common.ok')}
            </Button>
          }
        />

        <CustomModal
          isOpen={smsPaymentModal}
          toggle={() => this.toggleSmsPaymentModal('')}
          size="md"
          verticalCentering
          largeText
          title={t('common.zoleInfo')}
          body={
            <div className="payment-type-scrollarea">
              <div className="d-flex justify-content-center flex-column payment-type-message">
                <div className="d-flex justify-content-center">
                  {t('paymentType.youArePurchasing')}
                  {selectedProduct.type === 'gameMoney' ? (
                    <div className='payment-type-message-coin-wrapper'>
                      <Media src={coinImg} className="payment-type-message-coin" />
                      <span className="payment-type-coin-amount">{selectedProduct.amount}</span>
                      {' '}
                    </div>
                  ) : (
                    t(`paymentType.${selectedProduct.type}`)
                  )}

                  &nbsp;{t('paymentType.for')}
                  {
                    selectedProduct.discountType &&
                      (selectedProduct.discountType === constants.SPECIALPRICE || selectedProduct.discountType === constants.DISCOUNTPRICE) &&
                      selectedProduct.realPrice ? (
                        <>
                          &nbsp;
                          <span className="payment-type-old-price">
                            {selectedProduct.price}
                            &nbsp;
                            EUR
                          </span>
                          &nbsp;
                          <span className="payment-type-new-price">
                            {selectedProduct.realPrice}
                            &nbsp;EUR
                          </span>
                        </>
                      ) : selectedProduct.discountType && selectedProduct.discountType === constants.BONUS && selectedProduct.realPrice ? (
                        <>
                          &nbsp;
                          <span className="payment-type-price">
                            {selectedProduct.price}
                            &nbsp;
                            EUR
                          </span>
                          &nbsp;
                          <span className="payment-type-new-price">
                            {`+${selectedProduct.realPrice}`}
                            <Media src={coinImg} className="buy-page-coins-coin" />
                          </span>
                        </>
                      ) : (
                        <>
                          &nbsp;{selectedProduct.price}
                          &nbsp;EUR
                        </>
                      )
                  }
                </div>
                <div>
                  {selectedProduct.descriptionId && (
                    t(selectedProduct.descriptionId)
                  )}
                </div>
              </div>

              <Row className="payment-type-row d-flex align-items-center">
                <Media src={mobileImg} />
              </Row>
              <Row className="payment-type-row pt-1">
                <Col className="payment-type-col text-align-center">
                    {t('paymentType.smsInfo1')}
                </Col>
              </Row>
              <Row className="payment-type-row pt-1">
                <Col className="payment-type-col text-align-center">
                    {t('paymentType.smsInfo2', {price: selectedProduct.price})}
                </Col>
              </Row>
              <Row className="payment-type-row pt-2">
                <Col className="payment-type-col text-align-center sms-payment-footer-info">
                  {t('paymentType.smsInfo3')}
                </Col>
              </Row>
            </div>
          }
          footer={
            <Button onClick={() => this.toggleSmsPaymentModal('')}>
              {t('common.ok')}
            </Button>
          }
        />

        {socProvider && socProvider === 'inbox' ? (
          <Modal container={'div > div > div'} returnFocusAfterClose={false} isOpen={showInboxPayment} size="xl" className="inbox-payment-modal" toggle={this.closeInboxModal}>
            <ModalHeader
              toggle={this.closeInboxModal}
              style={{ padding: 0, height: 0 }}
              close={
                <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.closeInboxModal} />
              }
            />
            <ModalBody style={{ padding: 10 }} >
              <Iframe
                url={inboxIframeLink}
                width="100%"
                height="680px"
                id="inboxPaymentIframe"
                className="inboxPaymentIframe"
                display="initial"
                position="relative"
              />
            </ModalBody>
          </Modal>
        ) : (null)}
      </>
    );
  }
}

const mapStateToProps = state => ({
  // userSettings: state.userSettings[state.member.uid] || state.userSettings.default || {},
  soundOn: state.userSettings.soundOn,
  socProvider: state.member.socProvider,
  balance: state.member.balance,
  totalPoints: state.member.totalPoints,
  uid: state.member.uid || '',
  adsHidden: state.member.adsHidden || null,
  vipUntil: state.member.vipUntil || null,
  discounts: state.shop.discounts,
  lastShopTab: state.shop.lastShopTab || null,
  transactionComplete: state.shop.transactionComplete || false,
  paymentInfo: state.shop.paymentInfo || {},
  tournamentTickets: state.member.tournamentTickets || null,
});

const mapDispatchToProps = {
  initFBPay: initFBPayment,
  fbCallback: fbPaymentCallback,
  initDraugiemPay: initDraugiemPayment,
  initInboxPay: initInboxPayment,
  initStripePay: initStripePayment,
  initEveryPay: initEveryPayPayment,
  cancelEveryPay: cancelEveryPayPayment,
  fetchTransactionsHistory: getTransactionsHistory,
  claimGift: claimGiftCode,
  verifyGift: verifyGiftCode,
  fetchDiscounts: getDiscounts,
  setLastShopTabFunc: setLastShopTab,
  setTransactionCompleteFunc: setTransactionComplete,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(AdsPackageModal));
